import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataService } from 'app/shared/services/data.service';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import 'rxjs/add/observable/of';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { map } from 'rxjs/operators';
import { IDtoReceipt } from 'app/shared/models/dashboard/dto-receipt.model';
import { IDtoBonusCommission } from 'app/shared/models/dashboard/dto-bonus-commission.model';
import { IResult } from 'app/shared/models/result.model';
import { IDtoJobCandidateBasic } from 'app/shared/models/employee/dto-jobcandidate-basic.model';


@Injectable()
export class DashboardService {
    private payrollUrl = '';
    private requestUrl = '';
    private recruitmentUrl = '';
    private years: IDtoCatalog[] = [
        { id: 2010, name: '2010', additional: '' },
        { id: 2011, name: '2011', additional: '' },
        { id: 2012, name: '2012', additional: '' },
        { id: 2013, name: '2013', additional: '' },
        { id: 2014, name: '2014', additional: '' },
        { id: 2015, name: '2015', additional: '' },
        { id: 2016, name: '2016', additional: '' },
        { id: 2017, name: '2017', additional: '' },
        { id: 2018, name: '2018', additional: '' },
        { id: 2019, name: '2019', additional: '' },
        { id: 2020, name: '2020', additional: '' },
        { id: 2021, name: '2021', additional: '' },
        { id: 2022, name: '2022', additional: '' },
        { id: 2023, name: '2023', additional: '' },
        { id: 2024, name: '2024', additional: '' },
        { id: 2025, name: '2025', additional: '' },
        { id: 2026, name: '2026', additional: '' },
        { id: 2027, name: '2027', additional: '' },
        { id: 2028, name: '2028', additional: '' },
        { id: 2029, name: '2029', additional: '' },
        { id: 2030, name: '2030', additional: '' },
    ];
    private months: IDtoCatalog[] = [
        { id: 1, name: 'Enero', additional: '' },
        { id: 2, name: 'Febrero', additional: '' },
        { id: 3, name: 'Marzo', additional: '' },
        { id: 4, name: 'Abril', additional: '' },
        { id: 5, name: 'Mayo', additional: '' },
        { id: 6, name: 'Junio', additional: '' },
        { id: 7, name: 'Julio', additional: '' },
        { id: 8, name: 'Agosto', additional: '' },
        { id: 9, name: 'Septiembre', additional: '' },
        { id: 10, name: 'Octubre', additional: '' },
        { id: 11, name: 'Noviembre', additional: '' },
        { id: 12, name: 'Diciembre', additional: '' }
    ];
    constructor(private service: DataService, private configurationService: ConfigurationService) {
        if (this.configurationService.isReady) {
            this.payrollUrl = this.configurationService.serverSettings.payrollUrl;
            this.requestUrl = this.configurationService.serverSettings.requestUrl;
            this.recruitmentUrl = this.configurationService.serverSettings.recruitmentUrl;
        } else {
            this.configurationService.settingsLoaded$.subscribe(x => {
                this.requestUrl = this.configurationService.serverSettings.requestUrl;
                this.payrollUrl = this.configurationService.serverSettings.payrollUrl;
                this.recruitmentUrl = this.configurationService.serverSettings.recruitmentUrl;
            });
        }
    }
    public getCatalogYears(): Observable<IDtoCatalog[]> {
        return Observable.of(this.years);
    }
    public getCatalogMonths(): Observable<IDtoCatalog[]> {
        return Observable.of(this.months);
    }
    public getPayrollReceipts(ukey: string, year: number): Observable<IDtoReceipt[]> {
        const url = `${this.payrollUrl}api/Receipts/getPayrollReceipts?ukey=${ukey}&year=${year}`;
        return this.service.get(url).pipe(map((response: any) => {
            return response;
        }));
    }
    public getBonusCommissions(employeeId: number, period: Date): Observable<IDtoBonusCommission[]> {
        const url = `${this.requestUrl}api/Employees/getCommissionsAndBonus?employeeId=${employeeId}&period=${period}`;
        return this.service.get(url).pipe(map((response: any) => {
            return response;
        }));
    }
    public downloadFileReceipt(uuid: string, type: string): Observable<IResult> {
        const url = `${this.payrollUrl}api/Receipts/getPayrollReceiptPDF?uuid=${uuid}&type=${type}`;
        return this.service.get(url).pipe(map((response: any) => {
            return response;
        }));
    }
    public getAvailableDays(laborSeniorityDate: Date, employeeId: number, employeeNum: string, requisitionId: number): Observable<number> {
        const url = `${this.requestUrl}api/Holidays/getAvailableDays?laborSeniorityDate=${laborSeniorityDate}&employeeId=${employeeId}&employeeNum=${employeeNum}&requisitionId=${requisitionId}`;
        return this.service.get(url).pipe(map((response: any) => {
            return response;
        }));
    }
    public getCredential(jobCandidateId: number, companyId: number): Observable<any> {
        const obj = {
            jobCandidateId:jobCandidateId,
            companyId:companyId,
         }
        //const url = `https://rednovation.redpromex.com:11443/sirpm/rednovation_credencial.php?companyId=${companyId}&jobCandidateId=${jobCandidateId}`;
        //const url = 'http://redmty.dyndns.org:85/sirpm/rednovation_credencial.php?companyId=14&jobCandidateId=133982';
        const url = `${this.recruitmentUrl}api/JobCandidates/getCredential?companyId=${companyId}&jobCandidateId=${jobCandidateId}`;
        return this.service.get(url).pipe(map((response: any) => {
            return response;
        }));
    }
    public getTemplateFonacot(dto: IDtoJobCandidateBasic): Observable<IResult> {
        const url = `${this.recruitmentUrl}api/Templates/getTemplateFonacot`;
        return this.service.post(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public getTemplateLabor(dto: IDtoJobCandidateBasic): Observable<IResult> {
        const url = `${this.recruitmentUrl}api/Templates/getTemplateLabor`;
        return this.service.post(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public getTemplateKindergarten(dto: IDtoJobCandidateBasic): Observable<IResult> {
        const url = `${this.recruitmentUrl}api/Templates/getTemplateKindergarten`;
        return this.service.post(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
}
